// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w-full {
  width: 100%;
}
.h-full {
  height: 100%;
}
.justify-between {
  justify-content: space-between;
}
.danger {
  color: #FF0000 !important;
}
.primary {
  color: #1677ff !important;
}
.loading-container {
  width: 100%;
  height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.manageTable {
  margin-top: 1rem;
}
.title-text {
  font-size: 36px;
  color: #21134f;
}
.menu-group {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 10px;
}
.input-search {
  width: 200px;
}
.icon-group {
  justify-content: space-evenly;
}
.action-icon {
  font-size: 1.5em;
  cursor: pointer !important;
}
.manageTable * thead > tr > .table-td {
  background-color: #FBF6FF !important;
  color: #4A309D !important;
}
.manageTable * > td {
  font-size: 1em;
  font-weight: 600;
}
thead > tr > .table-td.center {
  text-align: center !important;
  background-color: #FBF6FF !important;
  color: #4A309D !important;
}
.manageTable*::-webkit-scrollbar {
  height: 8px !important;
}
.manageTable*::-webkit-scrollbar-thumb {
  background-color: #335ddc !important;
  border-radius: 5px !important;
}
.manageTable * ::-webkit-scrollbar-thumb:hover {
  background-color: #1449e9 !important;
}
.manageTable*::-webkit-scrollbar-track {
  background-color: #ffffff !important;
}
@media screen and (max-width: 576px) {
  .input-group {
    width: 100%;
  }
  .menu-group {
    width: 100%;
    justify-content: space-between;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/manageTable/index.less"],"names":[],"mappings":"AAIA;EACI,WAAA;AAHJ;AAMA;EACI,YAAA;AAJJ;AAOA;EACI,8BAAA;AALJ;AAQA;EACI,yBAAA;AANJ;AASA;EACI,yBAAA;AAPJ;AAUA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AARJ;AAWA;EACI,gBAAA;AATJ;AAYA;EACI,eAAA;EACA,cAAA;AAVJ;AAaA;EACI,aAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;AAXJ;AAcA;EACI,YAAA;AAZJ;AAeA;EACI,6BAAA;AAbJ;AAgBA;EACI,gBAAA;EACA,0BAAA;AAdJ;AAiBA;EACI,oCAAA;EACA,yBAAA;AAfJ;AAkBA;EACI,cAAA;EACA,gBAAA;AAhBJ;AAmBA;EACI,6BAAA;EACA,oCAAA;EACA,yBAAA;AAjBJ;AAoBA;EACI,sBAAA;AAlBJ;AAqBA;EACI,oCAAA;EACA,6BAAA;AAnBJ;AAsBA;EACI,oCAAA;AApBJ;AAuBA;EACI,oCAAA;AArBJ;AAwBA;EACI;IACI,WAAA;EAtBN;EAyBE;IACI,WAAA;IACA,8BAAA;EAvBN;AACF","sourcesContent":["@cardBackground: #FBF6FF;\n@textColor: #4A309D;\n@primaryColor: #7D44F3;\n\n.w-full {\n    width: 100%;\n}\n\n.h-full {\n    height: 100%;\n}\n\n.justify-between {\n    justify-content: space-between;\n}\n\n.danger {\n    color: #FF0000 !important;\n}\n\n.primary {\n    color: #1677ff !important;\n}\n\n.loading-container {\n    width: 100%;\n    height: 50vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.manageTable {\n    margin-top: 1rem;\n}\n\n.title-text {\n    font-size: 36px;\n    color: #21134f;\n}\n\n.menu-group {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    margin-bottom: 10px;\n}\n\n.input-search {\n    width: 200px;\n}\n\n.icon-group {\n    justify-content: space-evenly;\n}\n\n.action-icon {\n    font-size: 1.5em;\n    cursor: pointer !important;\n}\n\n.manageTable * thead>tr>.table-td {\n    background-color: @cardBackground !important;\n    color: @textColor !important;\n}\n\n.manageTable *>td {\n    font-size: 1em;\n    font-weight: 600;\n}\n\nthead>tr>.table-td.center {\n    text-align: center !important;\n    background-color: @cardBackground !important;\n    color: @textColor !important;\n}\n\n.manageTable*::-webkit-scrollbar {\n    height: 8px !important;\n}\n\n.manageTable*::-webkit-scrollbar-thumb {\n    background-color: #335ddc !important;\n    border-radius: 5px !important;\n}\n\n.manageTable * ::-webkit-scrollbar-thumb:hover {\n    background-color: #1449e9 !important;\n}\n\n.manageTable*::-webkit-scrollbar-track {\n    background-color: #ffffff !important;\n}\n\n@media screen and (max-width: 576px) {\n    .input-group {\n        width: 100%;\n    }\n\n    .menu-group {\n        width: 100%;\n        justify-content: space-between;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
